import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

const app = createApp(App);
store.dispatch('init');
app.use(router).use(store).mount('#app');
